/* eslint-disable import/prefer-default-export */
export const duration = 300;
